module.exports = __webpack_public_path__ + "img/video-camera.319ae396.png";